import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Domain } from 'app/models/domain.model';
import { DomainsService } from 'app/services/domains/domains.service';
import { EditDomainComponent } from './edit-domain/edit-domain.component';

@Component({
  selector: 'app-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.css']
})
export class DomainsComponent implements OnInit {

  title = 'Dominios';
  domains: Domain[];
  domainsToDisplay: any[];
  displayedColumns = ['customer', 'routes'];
  domainsDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) domainsPaginator: MatPaginator;
  @ViewChild(MatSort) domainSort: MatSort
  

  constructor(private dialog: MatDialog, 
    private router: Router, 
    private domainService: DomainsService) { }

  ngOnInit() {
    this.domainService.getDomains().subscribe(result => {
      this.domains = result;
      this.domainsDataSource = new MatTableDataSource<any>(this.domains);
      this.domainsDataSource.paginator = this.domainsPaginator;
      this.domainsDataSource.sort = this.domainSort;
      console.log('domains loaded!');
    });
  }

  ngAfterViewInit(){
    
  }

  openForm(){
    const dialogRef = this.dialog.open(EditDomainComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialogo cerrado!');
    })
  }

  openDomain(domain){
    this.router.navigate([`dashboard/domains/${domain.id}`])
  }

}
